import React from "react";
import { BrowserRouter } from "react-router";
import AppRouter from "./routes";
import Layout from "./Component/Layout";
import 'bootstrap/dist/css/bootstrap.min.css';

export default function App() {
  return (
    <>
      <Layout>
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
      </Layout>
    </>
  );
}
